module.exports = __webpack_public_path__ + "static/media/HOW DO YOU ADD CASES IN CASE MANAGEMENT.b7c8431a.png";